import React from "react";
import { Form, Input, Select, TreeSelect } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../utils/form";

const { SHOW_CHILD } = TreeSelect;

const ControlledInput = ({ control, errors, name, label, required }) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Input {...field} placeholder={"Enter name of package"} />
        </Form.Item>
      )}
    />
  );
};

const ControlledSelect = ({
  control,
  errors,
  name,
  required,
  options,
  multiple = false,
}) => {
  const error = getError({ errors, name });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Select
            mode={multiple ? "multiple" : null}
            {...field}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={options}
            placeholder={"Click here to select"}
          />
        </Form.Item>
      )}
    />
  );
};

const ControlledTreeSelect = ({ control, errors, name, required, options }) => {
  const error = getError({ errors, name });
  const tProps = {
    treeData: options,
    treeCheckable: true,
    showCheckedStrategy: SHOW_CHILD,
    placeholder: "Click here to select",
    style: {
      width: "100%",
    },
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <TreeSelect {...field} {...tProps}>
            {options}
          </TreeSelect>
        </Form.Item>
      )}
    />
  );
};

const CreatePackageForm = ({
  visible,
  setVisible,
  onSave,
  commodities,
  catalog,
  getTestCategories,
  control,
  errors,
  reset,
}) => {
  return (
    <>
      <p style={{ fontWeight: "500", fontSize: "14px" }}>Select Commodity :</p>
      <ControlledSelect
        required
        control={control}
        name="commodity"
        options={commodities}
        errors={errors}
      />
      <p style={{ fontWeight: "500", fontSize: "14px" }}>Package Name :</p>
      <ControlledInput
        required={true}
        name="name"
        errors={errors}
        control={control}
      />

      <p style={{ marginTop: "10px", fontWeight: "500", fontSize: "14px" }}>
        Select Test Parameters:
      </p>
      <ControlledTreeSelect
        required
        control={control}
        name="tests"
        label="Select Test Parameters"
        options={getTestCategories()}
        errors={errors}
      />
    </>
  );
};

export default CreatePackageForm;
